export function formatUppercase(value: string | undefined) {
  return value?.toUpperCase().trim() ?? '';
}
